var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntryLevel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.804199 10.4775C0.804199 10.4775 0.946199 15.2155 0.979199 15.7635C1.0232 16.4985 1.3072 17.3195 1.7812 17.8895C2.4502 18.6975 3.2382 18.9825 4.2902 18.9845C5.5272 18.9865 14.5222 18.9865 15.7592 18.9845C16.8112 18.9825 17.5992 18.6975 18.2682 17.8895C18.7422 17.3195 19.0262 16.4985 19.0712 15.7635C19.1032 15.2155 19.2452 10.4775 19.2452 10.4775",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49609 3.32998V2.95898C6.49609 1.73898 7.48409 0.750977 8.70409 0.750977H11.2861C12.5051 0.750977 13.4941 1.73898 13.4941 2.95898L13.4951 3.32998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99512 14.6788V13.3848",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 6.39003V9.85703C2.668 11.122 4.966 12.008 7.488 12.359C7.79 11.258 8.783 10.451 9.99 10.451C11.178 10.451 12.191 11.258 12.473 12.369C15.005 12.018 17.312 11.132 19.24 9.85703V6.39003C19.24 4.69603 17.877 3.33203 16.183 3.33203H3.817C2.123 3.33203 0.75 4.69603 0.75 6.39003Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryLevel);
export default __webpack_public_path__ + "static/media/entryLevel.2991b3fcf21625edf2f08769ae31b710.svg";
export { ForwardRef as ReactComponent };